document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.bogo__main');
  const toggle = document.querySelector('.bogo__icon'); 

  if (!panel || !toggle) return;


  requestAnimationFrame(() => {
    panel.classList.add('is-open');
  });

  toggle.addEventListener('click', () => {
    const isOpen = panel.classList.contains('is-open');

    if (isOpen) {
      panel.classList.remove('is-open');
      panel.classList.add('is-closed');
    } else {
      panel.classList.remove('is-closed');
      panel.classList.add('is-open');
    }

    
    toggle.classList.toggle('is-flipped', isOpen);
  });

  
});


document.addEventListener('DOMContentLoaded', function () {
  
  var $heroSlider = $('.js-custom-hero-slider');
  var slideCount = $heroSlider.find('.custom-hero__slide').length;

  if (slideCount > 1) {
    $heroSlider.slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 9000,
      fade: true,
      speed: 800,
      infinite: true,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      prevArrow: `<button class="slick-prev custom-hero__arrow" aria-label="Previous slide" type="button">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M18 12L13 7M18 12L13 17"
          stroke="#ffffff" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
      nextArrow: `<button class="slick-next custom-hero__arrow" aria-label="Next slide" type="button">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M18 12L13 7M18 12L13 17"
          stroke="#ffffff" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
      pauseOnHover: false,
      pauseOnFocus: false,
      draggable: false,
      swipe: true,
      touchMove: false,
      cssEase: 'ease-in-out',
      waitForAnimate: true
    });


    var $arrows = $heroSlider.find('.slick-prev, .slick-next');
    $('.custom-hero__arrows-container').append($arrows);
  }


});